import { render } from "./imeibindrecord.vue?vue&type=template&id=792493b0&scoped=true&ts=true"
import script from "./imeibindrecord.vue?vue&type=script&lang=ts"
export * from "./imeibindrecord.vue?vue&type=script&lang=ts"

import "./imeibindrecord.vue?vue&type=style&index=0&id=792493b0&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792493b0"]])

export default __exports__